import { type Common } from '../common.js';
import { type PatientOrder } from '../models/patient/order.js';
import { type User } from '../models/user.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/patient-orders';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByIds(ids?: string[]): Promise<(PatientOrder & { referredToProvider?: User })[]> {
    const url = this.common.constructPath(this.baseEndpoint, { ids });
    const patientOrders = await this.common.getJSON(url);
    return patientOrders;
  }
}
